import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import logo from "../../assets/images/nmd-logo.png";

const NAV_ITEMS = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  {
    name: "Our Services",
    path: "/services",
    dropdown: [
      "App Development",
      "Game Development",
      "Digital Marketing",
      "Data Science/Analytics",
      "Business Consulting",
      "Data Analysis",
    ],
  },
  { name: "Blogs", path: "/blogs" },
  { name: "Contact Us", path: "/contact" },
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState("Home");

  const navRef = useRef();

  // SCROLL EFFECT
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // CLOSE MENU WHEN CLICKING OUTSIDE
  useEffect(() => {
    const handleOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setMenuOpen(false);
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  // DROPDOWN CLICK (Mobile Double-Tap Logic)
  const handleDropdownClick = (e, itemName) => {
    const isMobile = window.innerWidth <= 900;

    if (itemName === "Our Services" && isMobile) {
      if (openDropdown === itemName) {
        // Second click → Open main Services page
        setActiveLink(itemName);
        setMenuOpen(false);
        setOpenDropdown(null);
      } else {
        // First click → Only open dropdown
        e.preventDefault();
        setOpenDropdown(itemName);
      }
    }
  };

  return (
    <header ref={navRef} className={`nmd-nav ${scrolled ? "nmd-nav--scrolled" : ""}`}>
      <div className="nmd-container">

        {/* LOGO */}
        <div className="nmd-left">
          <Link to="/" className="nmd-brand">
            <img src={logo} alt="NMD Infotech" className="nmd-logo" />
          </Link>
        </div>

        {/* NAV LINKS */}
        <nav className={`nmd-links ${menuOpen ? "open" : ""}`}>
          {NAV_ITEMS.map((item) => {
            const hasDropdown = !!item.dropdown;

            return (
              <div
                key={item.name}
                className={`nmd-item ${hasDropdown ? "has-dropdown" : ""}`}
                onMouseEnter={() =>
                  window.innerWidth > 900 && hasDropdown && setOpenDropdown(item.name)
                }
                onMouseLeave={() =>
                  window.innerWidth > 900 && hasDropdown && setOpenDropdown(null)
                }
              >
                <Link
                  to={item.path}
                  className={activeLink === item.name ? "active-nav" : ""}
                  onClick={(e) => {
                    if (hasDropdown) {
                      handleDropdownClick(e, item.name);
                    } else {
                      // Normal navigation → always close menu in mobile
                      setActiveLink(item.name);
                      setMenuOpen(false);
                      setOpenDropdown(null);
                    }
                  }}
                >
                  {item.name}
                  {hasDropdown && <span className="caret">▾</span>}
                </Link>

                {/* Dropdown */}
                {hasDropdown && (
                  <ul
                    className={`nmd-dropdown ${
                      openDropdown === item.name ? "show" : ""
                    }`}
                  >
                    {item.dropdown.map((d) => (
                      <li key={d}>
                        <Link
                          to={
                            d === "App Development"
                              ? "/services/app-development"
                              : d === "Game Development"
                              ? "/services/game-development"
                              : d === "Data Science"
                              ? "/services/data-science"
                              : d === "Business Consulting"
                              ? "/services/business-consulting"
                              : d === "Data Analysis"
                              ? "/services/data-analysis"
                              : d === "Digital Marketing"
                              ? "/services/digital-marketing"
                              : "/services"
                          }
                          onClick={() => {
                            setActiveLink("Our Services");
                            setMenuOpen(false);
                            setOpenDropdown(null);
                          }}
                        >
                          {d}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            );
          })}
        </nav>

        {/* CTA + HAMBURGER */}
        <div className="nmd-right">
          <Link
            to="/contact"
            className="nmd-cta"
            onClick={() => {
              setActiveLink("Contact Us");
              setMenuOpen(false);
            }}
          >
            Get In Touch
          </Link>

          <button
            className={`nmd-hamburger ${menuOpen ? "is-open" : ""}`}
            onClick={() => setMenuOpen((s) => !s)}
          >
            <span></span><span></span><span></span>
          </button>
        </div>

      </div>
    </header>
  );
};

export default Navbar;
